import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['accordion', 'content', 'icon', 'header', 'preview'];
  static values = { collapsed: Boolean };

  connect() {
    this.expanded = !this.collapsedValue;
    if (!this.expanded) {
      this.contentTarget.classList.add('hidden');
      this.accordionTarget.classList.remove('h-full');
    }
    this.togglePreview();
    this.setOpenStateAttr();
    this.updateIcon();
    this.updateRounded();
    this.updateHeaderBorder();

    this._onExpandEvt = () => this.expand();
    this._onCollapseEvt = () => this.collapse();
    this.element.addEventListener('accordion:expand', this._onExpandEvt);
    this.element.addEventListener('accordion:collapse', this._onCollapseEvt);
  }

  disconnect() {
    this.element.removeEventListener('accordion:expand', this._onExpandEvt);
    this.element.removeEventListener('accordion:collapse', this._onCollapseEvt);
  }

  toggle(event) {
    if (event.target.closest('[data-accordion-ignore-click]')) return;

    if (this.expanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    if (this.expanded) return;

    this.expanded = true;
    this.contentTarget.classList.remove('hidden');
    this.accordionTarget.classList.add('h-full');

    this.togglePreview();
    this.setOpenStateAttr();
    this.updateIcon();
    this.updateRounded();
    this.updateHeaderBorder();
  }

  collapse() {
    if (!this.expanded) return;

    this.expanded = false;
    this.contentTarget.classList.add('hidden');
    this.accordionTarget.classList.remove('h-full');

    this.togglePreview();
    this.setOpenStateAttr();
    this.updateIcon();
    this.updateRounded();
    this.updateHeaderBorder();
  }

  togglePreview() {
    if (!this.hasPreviewTarget) return;
    this.previewTarget.classList.toggle('hidden', this.expanded);
  }

  setOpenStateAttr() {
    this.element.dataset.accordionOpenValue = this.expanded ? 'true' : 'false';
  }

  updateIcon() {
    if (!this.hasIconTarget) return;
    this.iconTarget.classList.toggle('rotate-180', this.expanded);
    this.iconTarget.classList.add('transition-transform', 'duration-300');
  }

  updateRounded() {
    if (this.expanded) {
      this.accordionTarget.classList.add('rounded-3xl');
    } else {
      this.accordionTarget.classList.add('rounded-3xl');
    }
  }

  updateHeaderBorder() {
    this.headerTarget.classList.toggle('border-b', this.expanded);
  }
}
